import type { Command, CommandResult, GameState } from "@bd/sim";

export type ToWorker =
  | { type: "new"; seed: string; company: string; player: string; newGamePlus?: boolean; notebook?: Record<string, number> }
  | { type: "load"; state: GameState; player?: string; online?: boolean }
  | { type: "cmd"; id: number; cmd: Command }
  | { type: "speed"; speed: number }
  | { type: "step"; weeks: number };

export type FromWorker =
  | { type: "state"; state: GameState; at: number; msPerWeek: number }
  | { type: "result"; id: number; result: CommandResult }
  | { type: "pause"; reason: string; week: number }
  | { type: "error"; message: string };

/** ms per in-game week at each speed. Normal (1) is 30 s a week, about 120 weeks per real hour. */
export const SPEED_MS = [0, 30_000, 10_000, 2_500, 500, 120]; // 5 is for automated play-throughs only
export const SPEED_LABELS = ["Paused", "Normal", "Fast", "Faster", "Fastest", "Test"];
